module.exports = __webpack_public_path__ + "img/jiesuan2.1aa224c4.png";